import {Popup} from 'semantic-ui-react'
import {
  BsFillSkipBackwardFill,
  BsFillSkipForwardFill,
  BsPauseFill,
  BsPlayFill,
} from 'react-icons/bs'
import {AiFillStepBackward, AiFillStepForward} from 'react-icons/ai'
import './style.css'

export interface IVideoControlsProps {
  videoRef: React.RefObject<HTMLVideoElement | null>
  onPrevious?: () => void
  onNext?: () => void
  onSeekBack?: () => void
  onSeekForward?: () => void
  onPlayDisabled?: boolean
  onPreviousDisabled?: boolean
  onNextDisabled?: boolean
  onSeekBackDisabled?: boolean
  onSeekForwardDisabled?: boolean
}

export function VideoControls(props: IVideoControlsProps) {
  const {
    videoRef,
    onPlayDisabled,
    onPreviousDisabled,
    onNextDisabled,
    onSeekBackDisabled,
    onSeekForwardDisabled,
    onPrevious,
    onNext,
    onSeekBack,
    onSeekForward,
  } = props

  if (!videoRef.current) return null

  return (
    <div className='video-controls'>
      {onPrevious ?
        <Popup
          size='tiny'
          content='previous catalog item (q)'
          trigger={
            <button
              disabled={onPreviousDisabled}
              onFocus={(e) => e.target.blur()}
              children={<BsFillSkipBackwardFill />}
              onClick={onPrevious}
            />
          }
        />
      : null}
      {onSeekBack ?
        <Popup
          size='tiny'
          content='previous prediction (a)'
          trigger={
            <button
              disabled={onSeekBackDisabled}
              onFocus={(e) => e.target.blur()}
              children={<AiFillStepBackward />}
              onClick={onSeekBack}
            />
          }
        />
      : null}
      <Popup
        content='play/pause (space)'
        size='tiny'
        trigger={
          <button
            disabled={onPlayDisabled}
            onFocus={(e) => e.target.blur()}
            children={videoRef.current.paused ? <BsPlayFill /> : <BsPauseFill />}
            onClick={() => {
              if (!videoRef.current) return
              const v = videoRef.current
              if (v.paused) v.play()
              else v.pause()
            }}
          />
        }
      />
      {onSeekForward ?
        <Popup
          size='tiny'
          content='next prediction (d)'
          trigger={
            <button
              disabled={onSeekForwardDisabled}
              onFocus={(e) => e.target.blur()}
              children={<AiFillStepForward />}
              onClick={onSeekForward}
            />
          }
        />
      : null}
      {onNext ?
        <Popup
          size='tiny'
          content='next catalog item (e)'
          trigger={
            <button
              disabled={onNextDisabled}
              onFocus={(e) => e.target.blur()}
              children={<BsFillSkipForwardFill />}
              onClick={onNext}
            />
          }
        />
      : null}
    </div>
  )
}
